import {Action} from '@ngrx/store';
import {BijbEvent} from '../../../models/bijb-event';

export class DeleteChatsAction implements Action {
  public static readonly type = 'DeleteChatsAction';

  constructor(public bijbEvent: BijbEvent, public chatIds: number[]) {
  }

  public type = DeleteChatsAction.type;
}
